import { Text } from '@akin-home/text/native';
import { useWindowDimensions } from 'react-native';
import styled from 'styled-components/native';
import { Panel } from '../components/Panel';
import { ScreenHeader } from '../components/ScreenHeader';
import { ScreenTitle } from '../components/ScreenTitle';
import { DriveVideo } from '../videos/components/DriveVideo';

interface Props {
  screen_title: string;
  video_title?: string;
  video_description?: string;

  source: { uri: string } | { drive_id: string };

  action_button: React.ReactNode;
}

/**
 * Wrap a Screen in this component in order to display a video when a user first opens the screen
 * The video displayed should introduce the screen.
 */
export const SectionIntroScreen = (props: Props) => {
  const { width } = useWindowDimensions();

  return (
    <Screen>
      <Header>
        <ScreenTitle>{props.screen_title}</ScreenTitle>
      </Header>
      <Body>
        <VideoPanel style={{ minWidth: Math.min(0.95 * width, 500) }}>
          <VideoTextSection>
            <VideoPanelText variant="h3" weight="semibold">
              {props.video_title}
            </VideoPanelText>

            {props.video_description ? (
              <VideoPanelText weight="semibold">
                {props.video_description}
              </VideoPanelText>
            ) : null}
          </VideoTextSection>

          <VideoContainer>
            {props.source ? <DriveVideo source={props.source} /> : null}
          </VideoContainer>
        </VideoPanel>

        <ButtonRow>{props.action_button}</ButtonRow>
      </Body>
    </Screen>
  );
};

const Screen = styled.View`
  flex: 1;
`;

const Header = styled(ScreenHeader)`
  padding-bottom: 0;
`;

const Body = styled.View`
  align-items: center;
  flex: 1;
`;

const VideoTextSection = styled.View`
  gap: 15px;
`;

const VideoContainer = styled.View`
  flex: 1;
  flex-direction: row;
  width: 100%;
`;

const VideoPanel = styled(Panel)`
  padding: 30px;
  align-items: center;
  gap: 30px;
  max-width: 60%;
  /* min-width: 500px; */
  width: 100%;
  flex: 1;
`;

const VideoPanelText = styled(Text)`
  text-align: center;
`;

const ButtonRow = styled.View`
  flex-direction: row;
  align-items: center;
  padding: 20px;
`;
